// /src/pdf/builders/new_listeners/buildDoc.js
export function buildNewListenersDoc({
  t, shortcode, stationName,
  period, date1,
  start, end, total, labels, data, geo,
  fmtNumber, locale,
  logoDataUrl,
  chartDataUrl,
  serviceName
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('new_listeners.title')) || '';

  // ЛОГО слева
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Шапка
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        (period === 'day' ? (t('new_listeners.last_day') + ': ') : (t('new_listeners.last_day') + ': ')) + (date1 || ''),
        (start && end) ? (t('new_listeners.period') + ': ' + start + ' — ' + end) : ''
      ].filter(Boolean),
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // График
  if (chartDataUrl) {
    content.push({
      image: chartDataUrl,
      width: 520,
      margin: [0, 0, 0, 10]
    });
  }

  // Підсумок
  content.push({
    margin: [0, 2, 0, 8],
    stack: total > 0
      ? [
          { text: `${t('new_listeners.total')}: ${fmtNumber(total, locale)}`, bold: true, fontSize: 11 },
          ...(start && end ? [{ text: `${t('new_listeners.period')}: ${start} — ${end}`, fontSize: 10 }] : [])
        ]
      : [{ text: t('common.no_data'), bold: true, fontSize: 11 }]
  });

  // GEO-таблица (без эмодзи)
  const header = [
    { text: t('geo.table.country'), style: 'th', alignment: 'left' },
    { text: t('geo.table.count'), style: 'th', alignment: 'right' },
  ];
  const body = [
    header,
    ...((geo || []).map(row => ([
      { text: row.country || '', alignment: 'left' },
      { text: fmtNumber(row.cnt ?? 0, locale), alignment: 'right' },
    ])))
  ];

  content.push({
    table: {
      headerRows: 1,
      widths: ['*', 'auto'],
      body
    },
    layout: {
      fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
      hLineColor: '#e0e0e0',
      vLineColor: '#e0e0e0',
    },
  });

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true }
    },
  };
}

export { buildNewListenersDoc as default };
